module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": "",
      "to": "/Admin/Customer"
    }
  }, [_vm._v("New Customer")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Filter Customers"
    },
    model: {
      value: (_vm.filterCustomers),
      callback: function($$v) {
        _vm.filterCustomers = $$v
      },
      expression: "filterCustomers"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-list', _vm._l((_vm.filteredCustomers), function(customer) {
    return _c('v-list-group', {
      key: customer.key,
      class: customer.expanded ? 'grey lighten-4' : '',
      attrs: {
        "lazy": "",
        "no-action": ""
      },
      model: {
        value: (customer.expanded),
        callback: function($$v) {
          _vm.$set(customer, "expanded", $$v)
        },
        expression: "customer.expanded"
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "activator"
      },
      on: {
        "click": function($event) {
          return _vm.getVehicles(customer.key)
        }
      },
      slot: "activator"
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(customer.name))])], 1)], 1), _vm._v(" "), _c('v-container', {
      attrs: {
        "fluid": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('h3', {
      staticClass: "mb-2"
    }, [_vm._v("Vehicles")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-data-table', {
      attrs: {
        "items": _vm.vehicles,
        "item-key": "key",
        "headers": _vm.vehicleDataHeaders,
        "pagination": _vm.pagination,
        "hide-actions": "",
        "loading": _vm.gettingVehicles
      },
      on: {
        "update:pagination": function($event) {
          _vm.pagination = $event
        }
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', {
            on: {
              "click": function($event) {
                return _vm.getVehiclesDevices(props)
              }
            }
          }, [_c('td', {
            style: (props.item.VehicleReg ? 'font-style: normal;' : 'font-style: italic;')
          }, [_vm._v(_vm._s(props.item.VehicleReg ? props.item.VehicleReg : props.item.friendlyId ? props.item.friendlyId : 'TBC'))]), _vm._v(" "), _vm._l((_vm.templates), function(template) {
            return _c('td', {
              key: template.id,
              class: props.item.installedDevices && props.item.installedDevices[template.id] ? 'green--text' : 'red--text'
            }, [_vm._v(_vm._s(props.item.installedDevices &&
              props.item.installedDevices[template.id] ? 'Yes' : 'No'))])
          })], 2)]
        }
      }, {
        key: "expand",
        fn: function(props) {
          return [_c('v-card', {
            staticStyle: {
              "left": "0",
              "position": "sticky",
              "width": "80vw"
            },
            attrs: {
              "dark": ""
            }
          }, [_c('v-card-title', [_c('h3', [_vm._v("Installed Devices")])]), _vm._v(" "), _c('v-card-text', [(_vm.vehiclesDevices.length > 0) ? [_c('v-data-table', {
            attrs: {
              "items": _vm.vehiclesDevices,
              "headers": _vm.deviceColumns
            },
            scopedSlots: _vm._u([{
              key: "items",
              fn: function(props) {
                return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.formattedType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.IMEI))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.formattedCustomer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.formattedVehicle))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.formattedProduct))]), _vm._v(" "), _c('td', {
                  class: props.item.SIM === null || props.item.SIM.length < 19 ? 'error' : ''
                }, [_vm._v(_vm._s(props.item.SIM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.stockLocation))])])]
              }
            }], null, true)
          })] : _c('div', [_c('h3', [_vm._v("Vehicle does not have any devices installed")])])], 2)], 1)]
        }
      }], null, true)
    })], 1)], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64bf51bb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customer.vue
// module id = 752
// module chunks = 1